import { IActivityLog, ActivityTargetClass } from 'app/models/activity-log.model';
import { Component, Inject, HostListener, ElementRef, OnInit, ChangeDetectionStrategy } from '@angular/core';

import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ActivityStaffDetailsComponent } from '../activity-staff-details/activity-staff-details.component';
import { ActivityCameraGroupDetailsComponent } from '../activity-camera-group-details/activity-camera-group-details.component';
import { ActivityCameraVisitDetailsComponent } from '../activity-camera-visit-details/activity-camera-visit-details.component';
import { ActivityAlarmRouteDetailsComponent } from '../activity-alarm-route-details/activity-alarm-route-details.component';
import { ActivityReceiverGroupDetailsComponent } from '../activity-receiver-group-details/activity-receiver-group-details.component';
import { ActivityLocationDetailsComponent } from '../activity-location-details/activity-location-details.component';
import { ActivityAuthenticationDetailsComponent } from '../activity-authentication-details/activity-authentication-details.component';
import { ActivityDeviceDetailsComponent } from '../activity-device-details/activity-device-details.component';
import { ActivityCameraPauseDetailsComponent } from '../activity-camera-pause-details/activity-camera-pause-details.component';
import { ActivityAccessRoleDetailsComponent } from '../activity-access-role-details/activity-access-role-details.component';
import { ActivityMobileWhitelistDetailsComponent } from '../activity-mobile-whitelist-details/activity-mobile-whitelist-details.component';

@Component({
    selector: 'app-activity-details-dialog',
    imports: [ActivityStaffDetailsComponent, ActivityCameraGroupDetailsComponent, ActivityCameraVisitDetailsComponent, ActivityAlarmRouteDetailsComponent, ActivityReceiverGroupDetailsComponent, ActivityLocationDetailsComponent, ActivityAuthenticationDetailsComponent, ActivityDeviceDetailsComponent, ActivityCameraPauseDetailsComponent, ActivityAccessRoleDetailsComponent, ActivityMobileWhitelistDetailsComponent],
    templateUrl: './activity-details-dialog.component.html',
    changeDetection: ChangeDetectionStrategy.Default,
    styleUrls: ['./activity-details-dialog.component.css']
})
export class ActivityDetailsDialogComponent implements OnInit {
  readonly ActivityTargetClass = ActivityTargetClass;
  private isOpen = false;
  constructor(
    private dialogRef: MatDialogRef<ActivityDetailsDialogComponent>,
    private elementRef: ElementRef,
    @Inject(MAT_DIALOG_DATA) public log: IActivityLog
  ) { }

  ngOnInit() {
    setTimeout(() => {
      this.isOpen = true;
    }, 200);
  }

  @HostListener('document:click', ['$event'])
  onClickOutside(event: Event) {
    if (this.isOpen && !this.elementRef.nativeElement.contains(event.target)) {
      this.close();
    }
  }

  close(): void {
    this.dialogRef.close();
  }
}
